module.exports = __webpack_public_path__ + "static/media/Netflix-TheChefShow.f802a811.svg";